import { useTranslation } from 'react-i18next';

/**
 * Default Suspense fallback for lazy-loaded routes. Full-screen, minimal,
 * uses theme tokens so it matches both light and dark modes.
 */
export function PageLoader() {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-page text-text-secondary flex min-h-screen items-center justify-center"
    >
      <div className="flex items-center gap-3 text-sm">
        <span className="relative inline-flex h-2.5 w-2.5">
          <span className="bg-accent absolute inline-flex h-full w-full animate-ping rounded-full opacity-70" />
          <span className="bg-accent relative inline-flex h-2.5 w-2.5 rounded-full shadow-[0_0_12px_rgba(232,84,10,0.6)]" />
        </span>
        {t('common.loadingShort')}
      </div>
    </div>
  );
}
